var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17C3 19.2456 4.75439 21 7 21H17C19.2456 21 21 19.2456 21 17V16.9649V15.2456V8.01754C21 5.91228 19.386 3 17 3H7C4.75439 3 3 4.75439 3 7V17ZM5 17V16.4211L7 14.4211L9.05263 16.4561C9.57895 17 10.4211 17 10.9474 16.4561L15 12.4211L19 16.4035V17C19 18.2632 18.2632 19 17 19H7C5.73684 19 5 18.2632 5 17ZM6.50877 8.47368C6.50877 7.36842 7.38596 6.49123 8.52632 6.49123C9.63158 6.49123 10.5088 7.36842 10.5088 8.47368C10.5088 9.61404 9.63158 10.4912 8.52632 10.4912C7.38596 10.4912 6.50877 9.61404 6.50877 8.47368Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.0471ed19.svg";
export { ForwardRef as ReactComponent };